import React, { useState, useEffect } from "react"

import { navigate } from "gatsby"

import { Modal } from "../modal/modal"
import { isBrowser } from "../../../helpers/helpers"

export const CookiePolicy = () => {
  const getCookie = (cname) => {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  const setRootCookie = (cname, cvalue, exdays) => {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";domain=.businessdebtline.org;path=/";
  }

  const [isActive, setIsActive] = useState(
    isBrowser && getCookie('cookie_preferences') == 0 || isBrowser && getCookie('cookie_preferences') == ""
  )

  useEffect(() => {
    if(!isActive && isBrowser && getCookie('cookie_preferences') == 1) {
      window.dataLayer = window.dataLayer || [];
      function gtag() { window.dataLayer.push(arguments); }

      var analyticsConsentStatus
      if(getCookie('allow_analytics_cookies') == 1) {
          analyticsConsentStatus = 'granted';
      } else {
          analyticsConsentStatus = 'denied';
      }

      var advertisingConsentStatus
      if(getCookie('allow_advertising_cookies') == 1) {
          advertisingConsentStatus = 'granted';
      } else {
          advertisingConsentStatus = 'denied';
      }

      gtag('consent', 'update', {
          'ad_personalization': advertisingConsentStatus,
          'ad_storage': advertisingConsentStatus,
          'ad_user_data': advertisingConsentStatus,
          'analytics_storage': analyticsConsentStatus
      })

      gtag('event', 'consent_update', {
          'event_category': 'consent',
          'event_label': 'updated',
          'value': 1
      })
    }
  }, [isActive]);

  const closeDialog = () => {
    setIsActive(false)
  }

  const handleLearnMore = () => {
    closeDialog()
    navigate("/cookies-policy")
  }

  const acceptAllCookies = () => {
    setRootCookie('cookie_preferences', 1, 365)
    setRootCookie('allow_analytics_cookies', 1, 365)
    setRootCookie('allow_advertising_cookies', 1, 365)

    closeDialog()
  }

  const rejectAllCookies = () => {
    setRootCookie('cookie_preferences', 1, 365)
    setRootCookie('allow_analytics_cookies', 0, 365)
    setRootCookie('allow_advertising_cookies', 0, 365)

    closeDialog()
  }

  const manageCookies = () => {
    closeDialog()
    if(isBrowser) {
      setRootCookie('return_to_page', window.location.pathname, 1)
    }
    navigate("/manage-cookies")
  }

  const buttons = [
    {
      variant: "link",
      label: "Manage cookies",
      ariaLabel: "Manage cookies",
      className: "mr-1",
      onClick: manageCookies,
    },
    {
      variant: "link",
      label: "Reject all",
      ariaLabel: "Reject all cookies",
      className: "mr-1",
      onClick: rejectAllCookies,
    },
    {
      variant: "secondary",
      label: "Accept all",
      ariaLabel: "Accept all cookies",
      onClick: acceptAllCookies,
    },
  ]

  return (
    <Modal
      title={{ label: "We use Cookies on this site" }}
      className="cookie-options-prompt"
      isActive={isActive}
      onClose={closeDialog}
      buttons={buttons}
      hideClose="1"
    >
      <p>
        Click <a href="#" onClick={handleLearnMore}>Learn more</a> to view our cookies policy or choose an option below.
      </p>
      <hr />
    </Modal>
  )
}